import { IAppContext } from 'App/AppContext';
import Activity, { ActivityPriority, ActivityType } from 'models/activity';
import { EntityTypes } from 'models/entity';
import ResourceLink from 'models/resourceLink';
import { apiCreateActivity } from 'services/Api/activityService';
import { apiRequest } from 'services/Auth/authConfig';
import logger from 'services/Logging/logService';

// Records that the current user viewed a library item. The activity feeds the recently viewed list
// of the global search; a failure is logged and does not reach the user.
export const createLibraryItemReadActivity = async (link: ResourceLink, appContext: IAppContext): Promise<void> => {
  try {
    const activity = new Activity();
    activity.typeOfActivity = ActivityType.LibraryItemRead;
    activity.entity.typeOfEntity = EntityTypes.Link;
    activity.entity.entityId = link.linkId;
    activity.entity.entityName = link.linkName;
    activity.userId = appContext.user.id;
    activity.priority = ActivityPriority.Normal;

    const accessToken = await appContext.getAccessToken(apiRequest.scopes);
    await apiCreateActivity(activity, false, false, false, accessToken);
  } catch (err) {
    logger.debug('createLibraryItemReadActivity', err);
  }
};
